import getNumberSeparators from './getNumberSeparators';


export default function removeThousandSeparator(input: string): string {
    const separators = getNumberSeparators();
    return input.replace(new RegExp(separators.thousand, 'g'), '');
}
